import {
  Button,
  ButtonProps,
  NonTonalButtonMode,
} from "../../../../components/base/control/Button"
import { IconProps } from "../../../../components/Icon"

export interface TableActionButtonProps
  extends Omit<ButtonProps, "mode" | "tone">,
    Partial<Pick<IconProps, "icon">> {
  mode: NonTonalButtonMode
  label?: string
  isLoading?: boolean
  className?: string
  children?: React.ReactNode
}

export function TableActionButton(props: TableActionButtonProps) {
  const { icon, label, isLoading, children, ...buttonProps } = props
  return (
    <Button leftIcon={icon} loading={isLoading} size="small" {...buttonProps}>
      {label}
      {children}
    </Button>
  )
}
